import { MessageStates } from 'containers/MessageBox';
import { MessageData } from 'store/app/types';
import React from 'react';
import { Link } from 'react-router-dom';
import routes, { getRoute } from 'routes';
import { createUserFriendlyError, shouldLogout } from './secure-error';
import { REFRESH_TOKEN_ERROR } from 'store/app/constants';
import i18n from 'i18next';
const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
const UNAUTHORIZED = 'UNAUTHORIZED';

export function renderErrorMessage(error: any) {
  let status = error?.status;
  if (
    typeof error.status === 'string' &&
    error.status === INTERNAL_SERVER_ERROR
  ) {
    status = 500;
  }

  // Use secure error message instead of potentially verbose error messages
  const desc = createUserFriendlyError(error);

  if (
    error?.status !== 401 &&
    error.status !== UNAUTHORIZED &&
    error.message !== REFRESH_TOKEN_ERROR
  ) {
    let description: any = desc;
    if (desc && desc.includes('<br>')) {
      const descArr = desc.split('<br>');
      description = (
        <span>
          {descArr[0]}
          <br />
          {descArr[1]}
        </span>
      );
    }
    if (desc && desc.includes('<br><br>')) {
      const descArr = desc.split('<br><br>');
      description = (
        <span>
          {descArr[0]}
          <br />
          <br />
          {descArr[1]}
        </span>
      );
    }

    let type = MessageStates.ERROR;
    let title = '';
    
    // Check for specific error messages that need custom titles
    if (
      desc &&
      typeof desc === 'string' &&
      desc.includes('tax rates that have not yet been mapped')
    ) {
      title = i18n.t('common.new-tax-rates-detected');
      const connectionId = error?.connectionId;
      const mappingId = error?.mappingId;
      const mappingPageUrl =
        connectionId && mappingId
          ? getRoute('returns.edit', { connectionId, mappingId })
          : routes.organisations.all;
      description = (
        <span>
          {desc}
          <br />
          <br />
          <Link to={mappingPageUrl}>{i18n.t('signup.click-here')}</Link>
          {` ${i18n.t('common.go-to-mapping-page-and-map-new-tax-rates')}`}
        </span>
      );
    } else if (status === 410) {
      type = MessageStates.WARNING;
      title = i18n.t('common.warning');
    } else if (status === 403) {
      type = MessageStates.WARNING;
      title = i18n.t('common.unauthorized');
      description = i18n.t('global.action-rights-warning');
    }
    //for boris

    const message: MessageData = {
      title,
      description,
      type,
    };
    return message;
  } else {
    return null;
  }
}
